<template>
    <v-container class="container" fluid>
        <v-card>
            <v-form ref="form" v-model="valid" lazy-validation>
                <v-system-bar height="70px" dark color="secondary">
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text"
                        >Terminal Form
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-system-bar>

                <v-tabs centered>
                    <v-tab>General information</v-tab>
                    <v-tab>Contact information</v-tab>
                    <v-tab>Business Interruption</v-tab>
                    <v-tab-item>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="6">
                                <v-text-field
                                    label="Terminal Name"
                                    v-model="editedItem.TerminalName"
                                    required
                                    :rules="[
                                        v => !!v || 'Terminal Name is required'
                                    ]"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="4">
                                <v-text-field
                                    label="Address"
                                    v-model="editedItem.Address"
                                    required
                                    :rules="[v => !!v || 'Address is required']"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-autocomplete
                                    v-model="editedItem.GeographicalRegionId"
                                    :items="geographicalRegions"
                                    item-text="Region"
                                    item-value="GeographicalID"
                                    hide-details
                                    label="Geographical Region"
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-text-field
                                    label="City"
                                    v-model="editedItem.City"
                                    :rules="[v => !!v || 'City is required']"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-text-field
                                    label="Province"
                                    v-model="editedItem.Province"
                                    :rules="[
                                        v => !!v || 'Province is required'
                                    ]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    label="Postal Code"
                                    v-model="editedItem.PostalCode"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="1">
                                <v-text-field
                                    label="Geotab ID"
                                    v-model="editedItem.TerminalGeotabID"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-text-field
                                    label="Inactive Badge Expiration Period"
                                    v-model="
                                        editedItem.InactiveBadgeExpirationPeriod
                                    "
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    label="Special Instructions"
                                    v-model="editedItem.SpecialInstructions"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    <v-tab-item>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-text-field
                                    label="Terminal Phone"
                                    v-model="editedItem.TerminalPhone"
                                    :rules="[
                                        v => !!v || 'Terminal Phone is required'
                                    ]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    label="Terminal Fax"
                                    v-model="editedItem.TerminalFax"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-text-field
                                    label="Contact Name"
                                    v-model="editedItem.ContactName"
                                    :rules="[
                                        v => !!v || 'Contact Name is required'
                                    ]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    v-model="editedItem.ContactPhone"
                                    label="Contact Phone"
                                    :rules="[
                                        v => !!v || 'Contact Phone is required'
                                    ]"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-text-field
                                    label="After Hours Contact"
                                    v-model="editedItem.AfterHoursContact"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field
                                    label="After Hours Phone"
                                    v-model="editedItem.AfterHoursContactPhone"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5" justify="center">
                            <v-col cols="3">
                                <v-combobox
                                    required
                                    v-model="supplier"
                                    :items="suppliers"
                                    :item-text="'Supplier'"
                                    :rules="[
                                        v => !!v || 'Supplier is required'
                                    ]"
                                    :item-value="'id'"
                                    @change="selectSupplier()"
                                    label="Supplier"
                                    class="mx-3"
                                    auto-select-first
                                ></v-combobox>
                            </v-col>
                        </v-row>
                    </v-tab-item>

                    <v-tab-item>
                        <v-row class="mx-5 mt-5" justify="center">
                            <v-col cols="2">
                                <v-switch
                                    label="Business Interruption"
                                    v-model="editedItem.BusinessInterruption"
                                    hide-actions
                                ></v-switch>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    label="Business Start"
                                    v-model="editedItem.BusinessStart"
                                    v-mask="'####-##-## ##:##'"
                                    dense
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    label="Business End"
                                    v-model="editedItem.BusinessEnd"
                                    v-mask="'####-##-## ##:##'"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mx-5 mt-5" justify="center">
                            <v-col cols="6">
                                <v-textarea
                                    label="Business Comments"
                                    v-model="editedItem.BusinessComments"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                </v-tabs>
                <v-container>
                    <v-row justify="end">
                        <v-btn
                            dark
                            color="secondary"
                            class="mx-5 white--text"
                            @click="validate()"
                        >
                            Save
                            <v-icon right dark>mdi-content-save</v-icon>
                        </v-btn>
                        <v-btn
                            exact
                            dark
                            color="secondary"
                            class="mr-5 white--text"
                            :to="'/catalogs/terminals'"
                        >
                            Close
                            <v-icon right dark>mdi-close</v-icon>
                        </v-btn>
                    </v-row>
                </v-container>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    name: 'TerminalsForm',
    directives: {
        mask
    },
    data() {
        return {
            terminalID: 0,
            supplier: [],
            suppliers: [],
            defaultItem: {
                TerminalName: null,
                Address: null,
                City: null,
                Province: null,
                PostalCode: null,
                InactiveBadgeExpirationPeriod: null,
                SpecialInstructions: null,
                TerminalPhone: null,
                TerminalFax: null,
                ContactName: null,
                ContactPhone: null,
                AfterHoursContact: null,
                AfterHoursContactPhone: null,
                TerminalGeotabID: null,
                GeographicalRegionId: null
            },
            editedItem: {
                TerminalName: null,
                PrimarySupplier: null,
                Address: null,
                City: null,
                Province: null,
                PostalCode: null,
                InactiveBadgeExpirationPeriod: null,
                SpecialInstructions: null,
                TerminalPhone: null,
                TerminalFax: null,
                ContactName: null,
                ContactPhone: null,
                AfterHoursContact: null,
                AfterHoursContactPhone: null,
                Active: null,
                BusinessInterruption: null,
                BusinessStart: null,
                BusinessEnd: null,
                BusinessComments: null,
                TerminalGeotabID: null,
                GeographicalRegionId: null
            },
            valid: true,
            geographicalRegions: []
        };
    },
    mounted() {
        this.loadSuppliers();
        this.loadGeographicalRegions();
    },
    methods: {
        loadGeographicalRegions: function() {
            axios
                .get('terminal/geographical-regions')
                .then(response => {
                    this.geographicalRegions = response.data;
                    console.log(
                        'Geographical Regions: ',
                        this.geographicalRegions
                    );
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadTerminalData: function() {
            //this.$store.state.isLoading = true;
            this.terminalID = this.$store.state.editedTerminal.id;
            var str = this.$store;
            if (this.terminalID != 0) {
                axios
                    .get('terminal/' + this.terminalID, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        this.editedItem = Object.assign({}, response.data);
                        console.log(this.editedItem);
                        const index = this.suppliers.findIndex(elm => {
                            return elm.id == this.editedItem.PrimarySupplier;
                        });

                        this.supplier = this.suppliers[index];
                        console.log(this.suppliers[index]);
                        this.$store.state.editedTerminal.id = 0;
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            }
            this.$store.state.isLoading = false;
        },
        selectSupplier: function() {
            this.editedItem.PrimarySupplier = this.supplier.id;
        },
        loadSuppliers: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            axios
                .get('supplier', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.suppliers = response.data.data;
                    this.loadTerminalData();
                    this.dataLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        newTerminal: function() {
            this.$store.state.isLoading = true;

            this.editedItem.Active = true;
            var str = this.$store;
            axios
                .post('terminal', this.editedItem, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'New terminal added.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/terminals');
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        editTerminal: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .put('terminal/' + this.terminalID, this.editedItem, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .then(response => {
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Terminal information saved.'
                    });
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.$router.push('/catalogs/terminals');
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.save();
            }
        },
        save: function() {
            if (this.terminalID > 1) {
                this.editTerminal();
            } else {
                this.newTerminal();
            }
        }
    }
};
</script>
